import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Comment ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx._visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._visible) = $event)),
    onCancel: _ctx.handleCancel,
    width: "50%"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_table, {
        columns: _ctx.commentColumns,
        pagination: false,
        dataSource: _ctx.commentData,
        rowKey: "id",
        bordered: ""
      }, null, 8, ["columns", "dataSource"])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}